import {createPersister} from '@github-ui/react-query-persister'
import type {SendAnalyticsEventFunction} from '@github-ui/use-analytics'
import type {Label} from './label'

function isLabel(obj: unknown): obj is Label {
  if (typeof obj !== 'object' || obj === null) return false
  const item = obj as Record<string, unknown>
  return (
    typeof item.id === 'string' &&
    typeof item.color === 'string' &&
    typeof item.name === 'string' &&
    typeof item.nameHTML === 'string' &&
    (typeof item.description === 'string' || item.description === null || item.description === undefined) &&
    typeof item.url === 'string'
  )
}

export function isLabelPickerQueryData(
  obj: unknown,
): obj is {repositoryId: string; labels: Label[]; totalCount: number; labelsByNames?: Label[]} {
  if (typeof obj !== 'object' || obj === null) return false
  const data = obj as Record<string, unknown>
  return (
    typeof data.repositoryId === 'string' &&
    typeof data.totalCount === 'number' &&
    Array.isArray(data.labels) &&
    data.labels.every(isLabel) &&
    (data.labelsByNames === undefined || (Array.isArray(data.labelsByNames) && data.labelsByNames.every(isLabel)))
  )
}

const LabelPickerQueryDataValidator = {
  Check: (
    value: unknown,
  ): value is {repositoryId: string; labels: Label[]; totalCount: number; labelsByNames?: Label[]} =>
    isLabelPickerQueryData(value),
  Code: () => 'manual-validator',
  *Errors() {
    /* no-op */
  },
}

export function createLabelPersister(sendAnalyticsEvent: SendAnalyticsEventFunction) {
  return createPersister({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validator: LabelPickerQueryDataValidator as any,
    sendAnalyticsEvent,
    alwaysRefetch: true,
    enabled: true,
  })
}
